import $ from 'jquery';
import { resizeHeight } from './layout-resize';
import { themeGlossary } from '../glossary/theme-glossary';
import { SettingsGlossary } from '../glossary/settings-glossary';
import resolveUrl from '../common/resolve-url';
import storageWrapper from '../common/storage-wrapper';
import IndusoftUiStateService from './indusoftUiStateService';
export const indusoftUiStateService = new IndusoftUiStateService();

export function setupMainMenuClickHandlers() {
    handleHomeButtonClick();
    if ($('.header-main-menu').length) {
        handleMainMenuDropdownClicks();
        handleFullscreenClick();
        $('.theme-switcher-link').click(switchTheme);
    }
    handleLogoutClick();
}

export function setupUiPanelToggle() {
    const switcher = $('.switcher-ui-link');
    switcher.attr('title', indusoftUiStateService.tooltipSwitchSideBar);
    switcher.click(() => {
        indusoftUiStateService.toggleVisible();
        switcher.attr('title', indusoftUiStateService.tooltipSwitchSideBar);
    });
}

export function initializeTheme() {
    const theme = storageWrapper.getSelectedTheme() || themeGlossary.LIGHT;
    if (theme === themeGlossary.LIGHT) {
        setLightTheme();
    }
    else {
        setDarkTheme();
    }
}

function switchTheme() {
    const theme = storageWrapper.getSelectedTheme() || themeGlossary.LIGHT;
    if (theme === themeGlossary.LIGHT) {
        setDarkTheme();
    }
    else {
        setLightTheme();
    }
}

function setLightTheme() {
    setTheme(themeGlossary.LIGHT, 'Темная тема');
}

function setDarkTheme() {
    setTheme(themeGlossary.DARK, 'Светлая тема');
}

function setTheme(theme, oppositeTitle) {
    const $body = $('html');
    const logoUrl = $('#company_logo').data('logo-url');
    const $themeSwitcher = $('.theme-switcher-link');

    $('#company_logo').attr("src", `${logoUrl}?getDark=${theme === themeGlossary.DARK}`);

    setThemeClasses($body, theme);
    setThemeSwitcher($themeSwitcher, theme, oppositeTitle);
    storageWrapper.setSelectedTheme(theme);
}

function setThemeClasses($body, theme) {
    const oppositeTheme = theme === themeGlossary.LIGHT ? themeGlossary.DARK : themeGlossary.LIGHT;

    $body.removeClass(`${oppositeTheme}-theme`);
    if (!$body.hasClass(`${theme}-theme`)) {
        $body.addClass(`${theme}-theme`);
    }
}

function setThemeSwitcher($themeSwitcher, theme, oppositeTitle) {
    const oppositeClass = theme === themeGlossary.LIGHT ? themeGlossary.DARK : themeGlossary.LIGHT;

    $themeSwitcher.removeClass(oppositeClass);
    $themeSwitcher.addClass(theme);
    $themeSwitcher.attr('title', oppositeTitle);
}

function handleMainMenuDropdownClicks() {
    $('.header-system a').click(function (e) {
        if ($(this).parent().is('.active')) {
            $(this).parent().removeClass('active');

            return;
        }

        if (e.target.getAttribute('class').trim() === 'profile') {
            e.preventDefault();
        }
        $('.header-system').find('.active').removeClass('active');
        $(this).parent().addClass('active');
    });

    $(document).on('click', function (event) {
        if ($('.header-system-link.active a.profile').length) {
            const headerSystemDropdownElement = $('.header-system-dropdown')[0];
            const isElementContainsInProfileDropdown = $.contains(headerSystemDropdownElement, event.target);

            if (!isElementContainsInProfileDropdown && !$(event.target).hasClass('profile')) {
                $('.header-system-link.active').removeClass('active');
            }
        }
    });
}

function handleFullscreenClick() {
    $('.full-screen-mode-menu-link').click(function (e) {
        const isEnabled = !$(this).hasClass('isFullScreen');
        setFullscreenMode(isEnabled);
        storageWrapper.setIsFullscreenEnabled(isEnabled);
        e.preventDefault();

        $.ajax({
            url: resolveUrl('Layout/FullScreenModeState'),
            data: {isEnabled: isEnabled.toString()},
            type: 'POST',
        });

        if (window.isManualInput) {
            const $miWrapper = $('.js-mi-wrapper');
            if (storageWrapper.getIsFullscreenEnabled()) {
                $miWrapper.addClass('is-full-screen');
            } else {
                $miWrapper.removeClass('is-full-screen');
            }
        }
    });
}

function setFullscreenMode(isEnabled) {
    const headerBreadcrumbs = $('.header-breadcrumbs');
    headerBreadcrumbs.addClass('disabled');
    if (!isEnabled) {
        $('.header-main-menu').removeClass('isHide');
        headerBreadcrumbs.show();
        $('.header-breadcrumbs ul').show();
        $('.content').removeClass('nopadding');
        $('.full-screen-mode-menu-link').removeClass('isFullScreen');
        $('.full-screen-mode-menu-link').attr('title', 'Перейти в полноэкранный режим');
        $('.sidebar-overlay').css('top', '0px');
        $('.main-toolbar .reset-settings-btn').css('display', 'block');
        $('.main-toolbar .reset-settings-btn').css(
            'right',
            SettingsGlossary.RESET_BUTTON_NORMAL_MODE_OFFSET
        );

        if (window.commonSettings.isHeaderVisible) {
            $('.header-main-top').show();
        }

        if (window.commonSettings.isFooterVisible) {
            $('#footer').show();
        } else {
            $('#footer').hide();
        }

        if (window.commonSettings.IsBreadCrumbsVisible) {
            headerBreadcrumbs.removeClass('disabled');
            headerBreadcrumbs.show();
        }

        if (window.mainMenu)
            window.mainMenu.resizeFix();

        const isNavigationHidden = !$('.navigation-toggle-link').hasClass('active');
        if (!isNavigationHidden && storageWrapper.getIsNavMenuOpened()) {
            $('.main-wrapper').addClass('toggled mi-toggled');
            $('.navigation-toggle-link').addClass('active');
        } else {
            $('.main-wrapper').removeClass('toggled mi-toggled');
            $('.navigation-toggle-link').removeClass('active');
        }
    } else {
        $('.header-main-top').hide();
        $('.header-main-menu').addClass('isHide');
        headerBreadcrumbs.hide();
        $('#footer').hide();
        $('.header-breadcrumbs ul').hide();
        $('.content').addClass('nopadding');
        $('.full-screen-mode-menu-link').addClass('isFullScreen');
        $('.full-screen-mode-menu-link').attr('title', 'Выйти из полноэкранного режима');
        const isShowSwitch = !$('.header-system-link-switcher-ui').hasClass('hide');
        $('.main-toolbar .reset-settings-btn').css(
            'right',
            isShowSwitch
            ? SettingsGlossary.RESET_BUTTON_WITH_SWITCH_OFFSET
            : SettingsGlossary.RESET_BUTTON_DEFAULT_OFFSET
        );
        $('.sidebar-overlay').css('top', '35px');
        if ($('.sidebar-overlay').hasClass('active')) {
            $('.main-toolbar .reset-settings-btn').css('display', 'none');
        }

        if (storageWrapper.getIsNavMenuOpened()) {
            $('.main-wrapper').addClass('toggled mi-toggled');
            $('.navigation-toggle-link').addClass('active');
        } else {
            $('.main-wrapper').removeClass('toggled mi-toggled');
            $('.navigation-toggle-link').removeClass('active');
        }

    }
    resizeHeight();
    $(window).resize();
    $(window).trigger("fullScreenMode", [isEnabled]);
}

function handleHomeButtonClick() {
    $('a[data-user-homepage]').on('click',
        function (e) {
            e.preventDefault();
            const userHomepageUrl = $(this).attr('data-user-homepage');
            window.location.href = userHomepageUrl;
        });
}

function handleLogoutClick() {
    $('#logoutForm .stop-session-menu-link').on('click', function (e) {
        e.preventDefault();
        logOff();
    });
}

export function logOff() {
    if (typeof loginService !== 'undefined') {
        loginService?.logout();
    } else {
        document.getElementById('logoutForm').submit();
    }
}
